import React from 'react';

const HomeDepositAssumptionContent = () => {
  return (
    <React.Fragment>
      <p>
        This calculator helps you estimate the upfront costs associated with buying a property. The output or result of this calculator:
      </p>
      <ul>
        <li>
          is prepared without taking into consideration your personal financial circumstances;
        </li>
        <li>
          it is a general calculation only that does not include applicable fees payable;
        </li>
        <li>
          does not represent either a quote or pre-qualification for any of our loan products.
        </li>
      </ul>
      <p>
        The stamp duty rates used in the calculator are current and applicable for Australian purchasers as at September 2021 and are subject to change by the relevant States and Territories. Different stamp duty rates apply to foreign purchasers. You may be eligible for stamp duty exemptions/concessions such as first homeowners grant and other concessions that may be applicable to you. You should check with your solicitor, conveyancer or revenue office to confirm whether you are eligible for any concessions.
      </p>
      <p>
        The calculation is not an offer of credit to you but simply an estimate only of what you may be able to save or borrow based on the information that you have inputted in the calculator, please consider if it’s right for you. The amount that you may be eligible to save or borrow may be different when you complete a full application, and we capture all details relevant to our eligible lending criteria. The information is valid as at the date of this calculation which is subject to change without notice.
      </p>
      <p>
        Terms, conditions and eligibility criteria apply to all of our loan products and features. Fees, charges and disbursements are payable. Final approval is subject to our full credit assessment. We recommend that you consult our Loan Consultants or your professional adviser before making any decision based on this information.
      </p>
    </React.Fragment>
  )
}

export default HomeDepositAssumptionContent;
